import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class BackorderNotice extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog, product-card');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateBackorder);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog, product-card');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateBackorder);
  }

  /**
   * Updates the backorder notice from freshly rendered HTML.
   * @param {VariantUpdateEvent} event
   */
  updateBackorder = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newNotice = event.detail.data.html?.querySelector('backorder-notice');

    if (!newNotice) {
      this.hidden = true;
      this.innerHTML = '';
      return;
    }

    this.hidden = newNotice.hidden;
    morph(this, newNotice, { childrenOnly: true });
  };
}

if (!customElements.get('backorder-notice')) {
  customElements.define('backorder-notice', BackorderNotice);
}
